module.exports = __webpack_public_path__ + "img/wmsgeneral.7a1dbff8.png";